import { connect } from 'react-redux';

import { WebCategory } from '../../../../../domain/model/category/WebCategory';
import Component from '../components/js/Topics';
import { ITopStates } from '../store';

const mapStateToProps = (state: ITopStates) => ({
  list: state.topics.list,
  isError: state.topics.isError,
  category: state.globalNavigation.currentCategory,
  secValue: getSecByWebCategory(state.globalNavigation.currentCategory),
  listElementId: getListElementId(state.globalNavigation.currentCategory),
  mtestId: state.pageData.pageParam.mtestid
});

export default connect(mapStateToProps)(Component);

/**
 * WebCategoryより、sec文字列を取得
 * 該当するものがなかったときはundefined
 *
 * @param category  WebCategory
 * @returns string
 */
function getSecByWebCategory(category?: WebCategory): string | undefined {
  if (!category) {
    return undefined;
  }
  switch (category) {
    case WebCategory.MAJOR:
      return 'tpc_maj';
    case WebCategory.DOMESTIC:
      return 'tpc_dom';
    case WebCategory.WORLD:
      return 'tpc_wor';
    case WebCategory.BUSINESS:
      return 'tpc_bus';
    case WebCategory.ENTERTAINMENT:
      return 'tpc_ent';
    case WebCategory.SPORTS:
      return 'tpc_spo';
    case WebCategory.IT:
      return 'tpc_it';
    case WebCategory.SCIENCE:
      return 'tpc_sci';
    case WebCategory.LOCAL:
      return 'tpc_loc';
  }
  return undefined;
}

/**
 * UserActionLogger用のelementIdを返す
 * 該当するものがない場合はundefined
 *
 * @param category
 */
function getListElementId(category?: WebCategory): string | undefined {
  if (!category) {
    return undefined;
  }
  switch (category) {
    case WebCategory.MAJOR:
      return 'first-main-topics-text';
    case WebCategory.DOMESTIC:
      return 'first-domestic-topics-text';
    case WebCategory.WORLD:
      return 'first-international-topics-text';
    case WebCategory.BUSINESS:
      return 'first-economic-topics-text';
    case WebCategory.ENTERTAINMENT:
      return 'first-entertainment-topics-text';
    case WebCategory.SPORTS:
      return 'first-sports-topics-text';
    case WebCategory.IT:
      return 'first-it-topics-text';
    case WebCategory.SCIENCE:
      return 'first-science-topics-text';
    case WebCategory.LOCAL:
      return 'first-region-topics-text';
  }
  return undefined;
}
